import axios from 'axios';

export default axios.create({
    // backend server url with tailing slash
    // baseURL: 'http://localhost:8000/',
    // baseURL: 'http://localhost:8000/',
    baseURL: process.env.REACT_APP_API_URL,
});
